document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.announcement-marquee').forEach((el) => {
    const phrases = Array.from(el.querySelectorAll('.announcement-marquee__phrase'));
    if (phrases.length <= 1) return;

    const interval = parseInt(el.dataset.interval, 10) || 7000;
    let current = 0;

    setInterval(() => {
      phrases[current].classList.remove('is-active');
      current = (current + 1) % phrases.length;
      phrases[current].classList.add('is-active');
    }, interval);
  });
});